const textareas = document.querySelectorAll('textarea');

textareas.forEach((textarea) => {
 	textarea.addEventListener('input', () => {
    	textarea.parentNode.dataset.replicatedValue = textarea.value;
  	});
});